<template>
  <div>
    <template v-for="item in menuList">
      <!-- 原判断 item.children &&(item.children.length > 1 || (item.children[0].children && item.children[0].children.length)) -->
      <collapsed-menu
        v-if="item.children && item.children.length > 0"
        hide-title
        :root-icon-size="20"
        :icon-size="16"
        :theme="menuTheme"
        :parent-item="item"
        :key="`drop-menu-${item.name}`"
        @on-click="changeMenu"
      >
      </collapsed-menu>
      <Tooltip
        v-else
        disabled
        transfer
        :content="
          item.children && item.children[0]
            ? item.children[0].title
            : item.title
        "
        placement="right"
        :key="`drop-menu-${item.name}`"
      >
        <a
          @click="changeMenu(childName(item))"
          class="shrink-icon"
          :style="{ textAlign: 'center' }"
        >
          <Icon
            :custom="'i-custom icon-' + item.icon"
            :size="20"
            :key="'icon' + item.name"
          />
        </a>
      </Tooltip>
    </template>
  </div>
</template>

<script>
import CollapsedMenu from "./collapsed-menu.vue";

export default {
  name: "sidebarMenuShrink",
  components: { CollapsedMenu },
  props: {
    menuList: {
      type: Array,
    },
    iconColor: {
      type: String,
      default: "white",
    },
    menuTheme: {
      type: String,
      default: "darck",
    },
  },
  methods: {
    childName(item) {
      return item.children && item.children[0]
        ? item.children[0].projectId + "-" + item.children[0].name
        : item.projectId + "-" + item.name;
    },
    changeMenu(active) {
      const routeName = active.substring(active.indexOf("-") + 1);
      const projectId = active.substring(0, active.indexOf("-"));
      this.$emit("on-change", routeName, projectId);
    },
  },
};
</script>

<style scoped>
.shrink-icon {
  width: 60px;
  padding: 10px 0;
  cursor: pointer;
  font-size: 20px;
  color: #A7ABB3;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/views/main-components/shrinkable-menu/components/sidebarMenuShrink.vue